import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { AdminHeader, Field } from "../../components/admin/AdminUI";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  ["General", [["site_name", "Site Name"], ["tagline", "Tagline"], ["established_year", "Established Year", "number"], ["logo", "Logo URL"], ["favicon", "Favicon URL"]]],
  ["Contact", [["phone", "Phone"], ["email", "Email"], ["address", "Address"], ["google_maps_embed", "Google Maps Embed URL"]]],
  ["Social", [["facebook", "Facebook"], ["twitter", "Twitter / X"], ["instagram", "Instagram"], ["linkedin", "LinkedIn"], ["youtube", "YouTube"]]],
  ["Leader", [["leader_designation", "Leader Designation"], ["leader_name", "Leader Name"], ["leader_photo", "Leader Photo"], ["leader_message", "Leader Message", "textarea"]]],
  ["SEO / Analytics", [["meta_title", "Meta Title"], ["meta_description", "Meta Description", "textarea"], ["analytics_code", "Analytics Code", "textarea"]]],
];

export default function SettingsAdmin() {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setForm(r.data || {})); }, []);
  const upd = (k, type) => (e) => setForm({ ...form, [k]: type === "number" ? Number(e.target.value) : e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/admin/settings", form); toast.success("Settings saved"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <AdminHeader title="Website Settings" subtitle="Configure branding, contact information and SEO" />
      <form onSubmit={save} className="space-y-8">
        {FIELDS.map(([group, fields]) => (
          <div key={group} className="card-elev p-6">
            <h3 className="font-serif text-lg font-bold text-brand-text mb-5">{group}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {fields.map(([k, l, type]) => (
                <div key={k} className={type === "textarea" ? "md:col-span-2" : ""}>
                  <Field label={l}>
                    {type === "textarea"
                      ? <textarea rows={3} value={form[k] || ""} onChange={upd(k, type)} className="form-input" />
                      : <input type={type === "number" ? "number" : "text"} value={form[k] ?? ""} onChange={upd(k, type)} className="form-input" />}
                  </Field>
                </div>
              ))}
            </div>
          </div>
        ))}
        <div className="flex justify-end">
          <button disabled={busy} className="btn-primary" data-testid="settings-save"><Save size={16} /> {busy ? "Saving…" : "Save Settings"}</button>
        </div>
      </form>
    </div>
  );
}
